// extracted by mini-css-extract-plugin
export default {"container":"StatsRowDoubleColumn_container__F1V3B"};